import { Box, Divider, Text } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { FaArrowLeftLong } from "react-icons/fa6";
import { useNavigate, useParams } from "react-router-dom";
import LoadingSpinner from "../../../LoadingSpinner";
import LinksBox from "./LinksBox";

const CaseLinksPage = () => {
  const [caseLinks, setCaseLinks] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { id, personID } = useParams();

  useEffect(() => {
    const fetchActiveAssignments = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `/api/getLinks?id=${id}&person=${personID}`
        );
        const json = await response.json();
        setCaseLinks(json);
      } catch (error) {
        console.error("Error fetching active assignments:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchActiveAssignments();
  }, [id, personID]);
  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <Box>
      <Box display="flex" alignItems="center" gap={5}>
        <FaArrowLeftLong onClick={() => navigate(-1)} cursor="pointer" />
        <Text fontSize="md">Case Links View</Text>
      </Box>
      <Divider h="2px" bg="bgColor" />
      <Box my={4}>
        <LinksBox data={caseLinks} caseId={id} />
      </Box>
    </Box>
  );
};

export default CaseLinksPage;
